<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">{{ $t("labels.location") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-layout row="row" wrap="wrap">
        <v-flex xs12="xs12" md4="md4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line="single-line"
            hide-details="hide-details" clearable="clearable">
          </v-text-field>
        </v-flex>
        <v-flex xs12="xs12" md8="md8">
          <v-radio-group v-model="storeType" row="row">
            <v-radio label="All" value="all"> </v-radio>
            <v-radio label="Active" value="active"> </v-radio>
            <v-radio label="Locked" value="lock"> </v-radio>
            <v-radio label="Trial" value="trial"> </v-radio>
            <v-radio label="Cancel" value="cancel"> </v-radio>
            <v-radio label="Waiting for installation" value="installationDone"> </v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

    </v-card-title>
    <v-layout row wrap>
      <v-flex shrink>
        <JsonExcel name="walletBalance.xls" v-if="this.checkRightStatus(69)" :data="locations" :fields="downloadFields" class="pointer ml-2 downloadButton">
          Download Data
          <!-- <img src="download_icon.png" /> -->
        </JsonExcel>
        <!-- <v-btn color="info" flat="flat">Download</v-btn> -->
      </v-flex>
    </v-layout>

    <v-data-table :headers="headers" :items="locations" item-key="CSPID" :loading="loading" :search="search"
      :pagination.sync="pagination">
      <template slot="items" slot-scope="props">
        <tr @click="viewLocation(props.item)">
          <td class="text-xs-left pointer small-td"
            v-html="$options.filters.highlight(props.item.Store.CSPID, search.toLowerCase())">
            {{ props.item.Store.CSPID
            }}<v-icon small="small" v-if="props.item.Store.isLocked">lock</v-icon>
          </td>
          <td class="text-xs-left pointer">
            <div v-html="$options.filters.highlight(props.item.Store.businessName, search.toLowerCase())">
              <v-icon class="ml-1" small="small" v-if="props.item.Store.isCanceled" color="red">
                desktop_access_disabled </v-icon>{{ props.item.Store.businessName }}
            </div>
          </td>
          <td class="text-xs-left pointer"
            v-html="$options.filters.highlight(props.item.Store.businessPhone, search.toLowerCase())">{{
            props.item.Store.businessPhone | USPhoneNumber }}</td>
          <td class="text-xs-left pointer"
            v-html="$options.filters.highlight(props.item.Store.address, search.toLowerCase())">{{
            props.item.Store.address }}</td>
          <td class="text-xs-left pointer"
            v-html="$options.filters.highlight(props.item.serviceName, search.toLowerCase())">{{ props.item.serviceName }}
          </td>
          <td class="text-xs-right pointer">{{ props.item.Store.prepaidBalance | currency }}</td>
        </tr>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
        results.</v-alert>
    </v-data-table>
  </v-card>
</template>
<script>
import locationService from '../service.js';
import JsonExcel from "vue-json-excel";
import { mapGetters } from 'vuex';

export default {
  name: 'location-list',
  data() {
    return {
      storeType: 'active',
      downloadFields: {
        "Created At": {
          field: "Store.createDateTIme",
          callback: (value) => {
            return this.$moment(value).format("L LT");
          },
        },
        'CSP ID': 'Store.CSPID',
        'Store Name': 'Store.businessName',
        'Balance': 'Store.prepaidBalance',
      },
      headers: [
        {
          text: this.$t('labels.cspID'),
          align: 'left',
          sortable: true,
          value: 'Store.CSPID',
        },
        {
          text: this.$t('labels.storeName'),
          value: 'Store.businessName',
          sortable: true,
        },
        {
          text: this.$t('labels.phoneNumber'),
          value: 'Store.businessPhone',
          sortable: true,
        },
        {
          text: this.$t('labels.address'),
          value: 'Store.address',
          sortable: true,
        },
        {
          text: 'Service Type',
          value: 'serviceName',
          sortable: true,
        },
        {
          text: 'Wallet Balance',
          value: "Store.prepaidBalance",
          sortable: true,
        },
        // {
        //   text: this.$t("labels.dueInDays"),
        //   value: "dueInDays",
        //   sortable: true
        // }
      ],
      search: '',
      locations: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'businessName',
      },
    };
  },
  computed: {
    ...mapGetters('global', ["currentUser", "checkRightStatus"]),
  },
  components: { JsonExcel },
  watch: {
    storeType(val) {
      this.getList();
    },
    search(val) {
      if (!val) this.search = ''
    },
  },
  created() {
    if (this.$route.params.option) {
      this.storeType = this.$route.params.option;
      this.getList();
    } else {
      this.getList();
    }
  },
  methods: {
    create() {
      this.$router.push({ path: '/location/0/new' });
    },
    getList() {
      this.loading = true;
      return locationService
        .getAll({ list: this.storeType })
        .then((response) => {
          console.log('location ', response);
          this.locations = response.data;
          this.loading = false;
          return response;
        })
        .catch((err) => {
          console.log('err', err);
        });
    },
    viewLocation(location) {
      this.$router.push({ path: `/location/profile/${location.storeID}` });
    },
  },
};
</script>
<style>
.downloadButton {
  cursor: pointer;
  outline: 0;
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 16px;
  border-radius: .25rem;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.downloadButton:hover {
  color: #fff;
  background-color: #0b5ed7;
  border-color: #0a58ca;
}
</style>
